import EventReport from "./EventReport";

export default EventReport;
